import { render, staticRenderFns } from "./SimpleResidentList.vue?vue&type=template&id=753a0a8a"
import script from "./SimpleResidentList.vue?vue&type=script&lang=js"
export * from "./SimpleResidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports